import { Component } from '@angular/core';
import { FiDataFieldViewBase } from '@fi-app/data-field/data-field-view/data-field-view-base';

@Component({
    selector: 'data-field-view-active',
    template: '',
    standalone: false,
})
export class FiDataFieldViewActiveComponent extends FiDataFieldViewBase {
    // note: not used ?
    get isNotEmpty() {
        return false;
    }
}
